import React, { Component, Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import { injectIntl } from "react-intl";
var classNames = require("classnames");
var JDate = require("jalali-date");
import API from "../../api/index";

import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";

import StateButton from "Components/StateButton";
import moment from "jalali-moment";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import { Alert, Row, Card, CardBody, CardTitle, Form, FormGroup, Button, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Table, Collapse, CustomInput } from "reactstrap";
import { useRouteMatch } from "react-router-dom";

import NumericInput from "react-numeric-input";
import NumberFormat from "react-number-format";
import Rating from "Components/Rating";

import { Colxx, Separator } from "Components/CustomBootstrap";
import { NotificationManager } from "Components/ReactNotifications";

const jdate = new JDate();
class ViewOrder extends Component {
	constructor(props) {
		super(props);

		this.state = {
			reprintOrderClicked: false,
			reprintAddressClicked: false,
			isLoading: true,
			order: [],
			timeline: [],
			LinkVisits: [],
			loadError: false,
			curTime: new Date().toISOString().substr(11, 8),
		};

		this.getFactorTotalCounts = this.getFactorTotalCounts.bind(this);
		this.getFactorTotalPrice = this.getFactorTotalPrice.bind(this);
		this.updateSize = this.updateSize.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.handleReprintAddress = this.handleReprintAddress.bind(this);
		this.handleReprintOrder = this.handleReprintOrder.bind(this);
		this.loadData();
	}
	loadData(key) {
		API.order
			.view({ OrderId: this.props.match.params.orderId })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				if (data.order != null) {
					this.setState({
						order: data.order,
						timeline: data.timeline,
						LinkVisits: data.LinkVisits,
						isLoading: false,
					});
					this.updateSize();
				} else {
					this.setState({ isLoading: false, loadError: true });
					NotificationManager.error(this.state.url, "سفارش مورد نظر پیدا نشد.", 10000, null, null, "filled");
				}
			})
			.catch((error) => {
				this.setState({ isLoading: false, loadError: true });
				NotificationManager.error(this.state.url, "مشکل در دریافت سفارش.", 10000, null, null, "filled");
			});
	}
	handleReprintAddress() {
		return new Promise((success, fail, $this) => {
			this.setState({ reprintAddressClicked: true });

			API.address
				.print({ OrderId: this.state.order.OrderId })
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.MESSAGES !== undefined) {
						success("درخواست پرینت آدرس ثبت شد");
						for (var i = 0; i < data.MESSAGES.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.success(err, "درخواست پرینت آدرس ثبت شد", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.MESSAGES[i]
							);
							this.setState({
								reprintAddressClicked: false,
							});
						}
					} else {
						//
					}
				})
				.catch((error) => {
					fail("خطا در ثبت درخواست پرینت آدرس");
				});
		});
	}
	handleReprintOrder() {
		return new Promise((success, fail, $this) => {
			this.setState({ reprintOrderClicked: true });

			API.order
				.print({ OrderId: this.state.order.OrderId })
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.MESSAGES !== undefined) {
						success("درخواست پرینت فاکتور ثبت شد");
						for (var i = 0; i < data.MESSAGES.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.success(err, "درخواست پرینت فاکتور ثبت شد", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.MESSAGES[i]
							);
							this.setState({
								reprintOrderClicked: false,
							});
						}
					} else {
						//
					}
				})
				.catch((error) => {
					fail("خطا در ثبت درخواست پرینت فاکتور");
				});
		});
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateSize);
		this.updateSize();
	}
	updateSize() {
		if (!this.state.isLoading && document.querySelector(".auto-win-height") !== null) {
			window.autoWinWidth = document.querySelector(".auto-win-height").offsetWidth;
			document.querySelector(".auto-win-height").style.overflow = "hidden";
			document.querySelector(".auto-win-height").style.width = document.querySelector("#side-card").offsetWidth + "px";
			document.querySelector(".auto-win-height").style.height = window.innerHeight - document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight - 80 + "px";
			document.querySelector(".auto-win-height").style.position = "fixed";
			document.querySelector(".auto-win-height").style.top = document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight + 40 + "px";
			document.querySelector(".auto-win-height-scroll").style.height = window.innerHeight - document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight - 200 + "px";
			document.querySelector(".auto-win-height-scroll").style.overflow = "scroll";
		}
	}

	getFactorTotalCounts = () => {
		var total = 0;
		for (var i = 0; i < this.state.order.Products.length; i++) {
			total += this.state.order.Products[i].Count;
		}
		return total;
	};
	nl2br = (str) => {
		var breakTag = "<br/>";
		var replaceStr = "$1" + breakTag;
		// var replaceStr = '$1'+ breakTag +'$2';
		return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
	};
	getFactorTotalPrice = () => {
		var total = 0;
		for (var i = 0; i < this.state.order.Products.length; i++) {
			total += this.state.order.Products[i].Count * this.state.order.Products[i].Price;
		}

		return total;
	};

	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : this.state.loadError ? (
			<Alert color="danger">مشکل در دریافت سفارش. لطفا صفحه را دوباره بارگذاری کنید.</Alert>
		) : (
			<Fragment>
				<Row className="mb-4">
					<Colxx xxs="12">
						<Form>
							<FormGroup row>
								<Colxx sm={6}>
									<Card className="timeline-card " style={{ backgroundColor: "transparent" }} id={"side-card"}>
										<CardBody style={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
											<CardTitle>
												<div className={"iconsminds-calendar-4 headingicon"} />
												گاه شمار سفارش شماره #{this.state.order.OrderId}
											</CardTitle>
											<div className="">
												<Timeline lineColor={"#ddd"}>
													{this.state.timeline.map((item, index) => {
														return (
															<TimelineItem
																key={index}
																dateText={item.date}
																dateComponent={
																	<span className="timeline-item-date">
																		<time className="timeline-item-dateinner" title="1400-02-03 14:45:13">
																			{item.dow}
																			<br />
															{moment((item.date || "").split("T")[0]).locale("fa").format("DD MMMM YYYY")}
																			<br />
															{(item.date || "").split("T")[1]}
																			<br />
																			<span className={"timelineoperator"}>
																				{/* <i className={"iconsminds-consulting"}></i> */}
																				{item.type == "linkvisit" ? item.info.IP : item.operator}
																			</span>
																		</time>
																	</span>
																}
																className={classNames({
																	"timeline-item-important": item.important,
																	"timeline-item-success": item.type == "created" || item.type == "processed_success" || item.type == "payment_SITE" || item.type == "payment_CARD" || item.type == "payment_CASH",
																	"timeline-item-danger": item.type == "processed_canceled",
																	"timeline-item-payment": false,
																	"timeline-item-note": item.type == "note" || item.type == "linkvisit",
																	"timeline-item-customer": item.type == "customerfeedback" || item.type == "customer_rating",
																})}
															>
																<h3 className={"timelinetitle timelinetitlewithtext"}>
																	<i
																		className={classNames({
																			"iconsminds-add-file": item.type == "created" ? true : false,
																			"iconsminds-mail-favorite": item.type == "sms" ? true : false,
																			"simple-icon-eye": item.type == "linkvisit" ? true : false,
																			"simple-icon-globe": item.type == "payment_SITE" ? true : false,
																			"iconsminds-coins": item.type == "payment_CASH" ? true : false,
																			"iconsminds-credit-card": item.type == "payment_CARD" ? true : false,
																			"simple-icon-call-end": item.type == "missedCall" ? true : false,
																			"simple-icon-bubbles": item.type == "whatsappMessage" ? true : false,
																			"simple-icon-call-out": item.type == "call" ? true : false,
																			"simple-icon-check": item.type == "processed_success" ? true : false,
																			"simple-icon-close": item.type == "processed_canceled" ? true : false,
																			"simple-icon-notebook": item.type == "note" ? true : false,
																			"simple-icon-star": item.type == "customer_rating" ? true : false,
																			"iconsminds-business-man-woman": item.type == "customerfeedback" ? true : false,
																		})}
																	></i>
																	{item.title}
																</h3>
																{item.info === false ? (
											<span className={"timelinecomment"} style={{ display: (item.comment || "").length > 0 ? "block" : "none" }}>
												{(item.comment || "").split("\n").map((content, key) => {
																			if (content.trim() == "") {
																				return;
																			}
																			return <p key={key}>{content}</p>;
																		})}
																	</span>
																) : (
																	<span className={"timelineinfo"} className="visitor-info">
																		<span className={"cardtitleicons"}>
																			<i className={"simple-icon-globe-alt"}></i>
													{(item.info.Country || "").split(",")[0] || "—"}
																		</span>
																		<span className={"cardtitleicons"}>
																			<i className={"simple-icon-globe"}></i>
																			{item.info.BrowserName} {item.info.BrowserVersion}
																		</span>
																		<span className={"cardtitleicons"}>
																			<i
																				className={classNames({
																					"iconsminds-monitor-3 ": item.info.DeviceType == "desktop",
																					"iconsminds-smartphone-4": item.info.DeviceType != "desktop",
																				})}
																			></i>
																			{item.info.OSName} {item.info.OSVersion}
																		</span>
																	</span>
																)}
															</TimelineItem>
														);
													})}

													{/* <TimelineItem
                              key={10001}
                              dateText={"2323232323"}
                              dateComponent={(
                                <span className="timeline-item-date">
                                  <time className="timeline-item-dateinner" title="1400-02-03 14:45:13"
                                  >
                                    {jdate.format('dddd')}
                                    <br />
                                    {jdate.format('YYYY-MM-DD')}
                                    <br />
                                    {this.state.curTime}
                                    <br />
                                    <span className={"timelineoperator"}>
                                      <i className={"iconsminds-consulting"}></i>
                                      رامین
                                    </span>
                                  </time>

                                </span>
                              )}
                              className={"new-entry-item"}
                            >
                              <h3 className={"timelinetitle "}>
                                <i className={""}></i>
                                ثبت رویداد جدید
                              </h3>
                              <select>
                                <option value="-1">تماس بی پاسخ</option>
                                <option value="-1">پیام واتس اپ</option>
                                <option value="-1">تماس تلفنی</option>
                                <option value="-1">یادداشت اپراتور</option>
                                <option value="-1">فیدبک مشتری</option>
                              </select>


                              <CustomInput
                                type="checkbox"
                                id="exCustomRadio"
                                name="customRadio"
                                label="رویداد مهم"
                              />

                              <textarea>

                              </textarea>
                              <Button color="primary" disabled={true} className="default mb-2" style={{ "float": "left" }}>
                                ثبت
                              </Button>
                            </TimelineItem>*/}
												</Timeline>
											</div>
										</CardBody>
									</Card>
								</Colxx>

								<Colxx sm={6}>
									<Card>
										<CardBody style={{ paddingBottom: "0px" }}>
											<CardTitle>
												<div className={"iconsminds-billing headingicon"} />
												سفارش شماره #{this.state.order.OrderId}
												<div style={{ float: "left", fontSize: "14px" }} className={"text-muted"}>
													<i
														className={classNames({
															"iconsminds-business-man": this.state.order.Customer.Gender == "male" ? true : false,
															"iconsminds-business-woman": this.state.order.Customer.Gender == "female" ? true : false,
														})}
													></i>
													{this.state.order.Customer.Name} {this.state.order.Customer.SurName} - &nbsp;
													<a className={"text-muted"} href={"/app/customers/view-customer/" + this.state.order.Customer.Mobile}>
														{this.state.order.Customer.Mobile}
														<div className={" simple-icon-arrow-left-circle icongotoorder"} />
													</a>
												</div>
											</CardTitle>

											{this.state.order.Address != false ? (
												<table style={{ width: "100%" }} className={"address-item"}>
													<tbody>
														<tr>
															<td style={{ width: "100px", fontWeight: "bold" }}>تحویل گیرنده:</td>
															<td style={{ width: "calc(50% - 100px)" }}>
																<i
																	className={classNames({
																		"iconsminds-business-man": this.state.order.Address.Gender == "male" ? true : false,
																		"iconsminds-business-woman": this.state.order.Address.Gender == "female" ? true : false,
																	})}
																></i>
																{this.state.order.Address.Name} {this.state.order.Address.SurName}
															</td>
															<td style={{ width: "25%" }}>
																<i className={"simple-icon-screen-smartphone"}></i>&nbsp;
																{this.state.order.Address.Mobile}
															</td>
															<td style={{ width: "25%" }}>
																<i className={"iconsminds-old-telephone"}></i>&nbsp;
																{this.state.order.Address.Tel}
															</td>
														</tr>
														<tr>
															<td>
																<strong>آدرس:&nbsp;</strong>
															</td>
															<td colSpan={3}>
																{this.state.order.Address.State} - &nbsp;
																{this.state.order.Address.City} - &nbsp;
																{this.state.order.Address.Zone != "محدوده" ? <span>{this.state.order.Address.Zone} - &nbsp;</span> : <span />}
																{this.state.order.Address.Address} &nbsp;
															</td>
														</tr>
														<tr>
															<td>
																<strong>کد پستی:&nbsp;</strong>
															</td>
															<td colSpan={3}>{this.state.order.Address.PostCode}</td>
														</tr>
													</tbody>
												</table>
											) : (
												<Alert color="light" style={{ color: "gray" }}>
													تا کنون آدرسی برای این سفارش ثبت نشده است.
												</Alert>
											)}
											<br />
											<div>
												<span className={"cardtitleicons"}>
													<i className={"iconsminds-consulting"}></i>
													{this.state.order.OperatorName}
												</span>
												<span className={"cardtitleicons"}>
													{classNames({
														"کارت به کارت": this.state.order.PaymentType == "CARD" ? true : false,
														"درگاه سایت": this.state.order.PaymentType == "SITE" ? true : false,
														"پرداخت نقدی": this.state.order.PaymentType == "CASH" ? true : false,
														"پرداخت پوز": this.state.order.PaymentType == "POS" ? true : false,
														"بدون پرداخت": this.state.order.PaymentType == "NONE" ? true : false,
													})}
												</span>
												<span className={"cardtitleicons"}>
													{classNames({
														حضوری: this.state.order.Type == "SHOP" ? true : false,
														سایت: this.state.order.Type == "SITE" ? true : false,
														چت: this.state.order.Type == "CHAT" ? true : false,
													})}
												</span>
												<span className={"cardtitleicons"}>
													<i
														className={classNames({
															"iconsminds-financial": this.state.order.Position == "PAYMENT" ? true : false,
															"iconsminds-box-close": this.state.order.Position == "PROCESS" ? true : false,
															"iconsminds-data-center": this.state.order.Position == "ARCHIVE" ? true : false,
														})}
													></i>
													{classNames({
														"صف پرداخت": this.state.order.Position == "PAYMENT" ? true : false,
														"صف پردازش": this.state.order.Position == "PROCESS" ? true : false,
														آرشیو: this.state.order.Position == "ARCHIVE" ? true : false,
													})}
												</span>
												<span className={"cardtitleicons"}>
													<i
														className={classNames({
															"simple-icon-check": this.state.order.Result == "SUCCESS" ? true : false,
															"simple-icon-close": this.state.order.Result == "FAILED" ? true : false,
															"simple-icon-question": this.state.order.Result == "FAILED" ? true : false,
														})}
													></i>
													{classNames({
														"تحویل شده": this.state.order.Result == "SUCCESS" ? true : false,
														"کنسل شده": this.state.order.Result == "FAILED" ? true : false,
														"تعیین نشده": this.state.order.Result == "FAILED" ? true : false,
													})}
												</span>
												{this.state.order.Address != false ? (
													<StateButton
														disabled={this.state.reprintAddressClicked}
														color="light"
														id="reprintaddressbtn"
														className="default mb-2 outline-dark-btn float-left"
														style={{ display: "inline-block", float: "left" }}
														onClick={this.handleReprintAddress}
													>
														<i className="simple-icon-printer"></i>&nbsp; پرینت مجدد آدرس
													</StateButton>
												) : (
													<div />
												)}
											</div>
										</CardBody>
										<div className={"cutline"}></div>
										<CardBody>
											<table className="table">
												<thead>
													<tr>
														<th colSpan={3}>نام محصول</th>
														<th style={{ textAlign: "center" }}>قیمت واحد</th>
														<th style={{ textAlign: "center" }}>تعداد </th>
														<th style={{ textAlign: "center", minWidth: "120px" }}>قیمت کل</th>
													</tr>
												</thead>
												<tbody>
													{this.state.order.Products.map((row, index) => (
														<FactorTableRow key={index} data={row} />
													))}
												</tbody>
												<tfoot>
													<tr>
														<td colSpan="6"></td>
													</tr>
													<tr className="order-new-table-totalrow" style={{ borderTop: "3px solid lightgray" }}>
														<td colSpan="2" style={{ maxWidth: "40px" }}>
															<div style={{ fontSize: "24px", color: "gray" }} className={"glyph-icon iconsminds-cash-register-2"} />
														</td>
														<td className="order-new-table-width55 font-weight-semibold text-muted" style={{ color: "gray" }}>
															جمع کل
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ color: "gray" }}>
															-
														</td>
														<td className="order-new-table-width15  " style={{ color: "gray" }}>
															<NumberFormat value={this.getFactorTotalCounts()} displayType={"text"} suffix={" عدد"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
														<td className="order-new-table-width15  " style={{ color: "gray" }}>
															<NumberFormat value={this.getFactorTotalPrice()} displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
													</tr>
													{this.state.order.CouponUse !== false ? (
														this.state.order.CouponUse.map((row) => (
															<tr className="order-new-table-totalrow">
																<td style={{ width: "40px", verticalAlign: "middle" }} colSpan="2">
																	<div style={{ fontSize: "24px", color: "black" }} className={"glyph-icon iconsminds-project"} />
																</td>
																<td colSpan="2" className="order-new-table-width55 font-weight-semibold " style={{ color: "black", verticalAlign: "middle" }}>
																	کوپن
																</td>
																<td colSpan="2" className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																	<div>
																		<a href={"/app/crm/coupon/view/" + row.couponId} target="_blank">
																			{" "}
																			<div className={"coupon"} style={{ color: "#556270" }}>
																				<span>{row.coupon.code}</span>
																			</div>{" "}
																		</a>
																	</div>
																</td>
															</tr>
														))
													) : (
														<tr />
													)}
													<tr className="order-new-table-totalrow">
														<td style={{ width: "40px" }} colSpan="2">
															<div style={{ fontSize: "24px", color: this.state.order.DiscountAmount > 0 ? "black" : "lightgray" }} className={"glyph-icon iconsminds-dollar"} />
														</td>
														<td colSpan="2" className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.order.DiscountAmount > 0 ? "black" : "lightgray" }}>
															تخفیف کل
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ color: this.state.order.DiscountAmount > 0 ? "black" : "lightgray" }}>
															{this.state.order.DiscountPercent} %
														</td>
														<td className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.order.DiscountAmount > 0 ? "black" : "lightgray", textAlign: "center" }}>
															<NumberFormat
																value={this.state.order.DiscountAmount}
																displayType={"text"}
																suffix={" تومان"}
																thousandSeparator={true}
																renderText={(value, price) => <span className="dataItemCount">{value}</span>}
															/>
														</td>
													</tr>
													<tr className="order-new-table-totalrow">
														<td style={{ width: "40px" }} colSpan="2">
															<div style={{ fontSize: "24px", color: this.state.order.AdditionalFee > 0 ? "black" : "lightgray" }} className={"glyph-icon iconsminds-scooter"} />
														</td>
														<td colSpan="2" className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.order.AdditionalFee > 0 ? "black" : "lightgray" }}>
															هزینه حمل و جانبی
														</td>
														<td></td>
														<td className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.order.AdditionalFee > 0 ? "black" : "lightgray", textAlign: "center" }}>
															<NumberFormat
																value={this.state.order.AdditionalFee}
																displayType={"text"}
																suffix={" تومان"}
																thousandSeparator={true}
																renderText={(value, price) => <span className="dataItemCount">{value}</span>}
															/>
														</td>
													</tr>
													<tr className="order-new-table-totalrow">
														<td style={{ width: "40px" }} colSpan="2">
															<div style={{ fontSize: "24px", color: this.state.order.AdditionalFee > 0 ? "black" : "lightgray" }} className={"glyph-icon iconsminds-financial"} />
														</td>
														<td colSpan="2" className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.order.VAT > 0 ? "black" : "lightgray" }}>
															مالیات بر ارزش افزوده
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ color: this.state.order.VAT > 0 ? "black" : "lightgray" }}>

															۱۰٪
															</td>
														<td className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.order.VAT > 0 ? "black" : "lightgray", textAlign: "center" }}>
															<NumberFormat value={this.state.order.VAT} displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
													</tr>
													<tr className="order-new-table-totalrow">
														<td style={{ width: "40px" }} colSpan="2">
															<div style={{ fontSize: "24px", color: "black" }} className={"glyph-icon iconsminds-coins"} />
														</td>
														<td className="order-new-table-width55 font-weight-semibold " style={{ color: "black" }}>
															قابل پرداخت
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ color: "black" }}>
															-
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ color: "black" }}>
															<NumberFormat value={this.getFactorTotalCounts()} displayType={"text"} suffix={" عدد"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ color: "black" }}>
															<NumberFormat value={this.state.order.Payable} displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
													</tr>
													{this.state.order.NotePublic != null && this.state.order.NotePublic.trim() !== "" ? (
														<tr>
															<td colSpan="2">
																<div style={{ fontSize: "24px", color: "black" }} className={"glyph-icon simple-icon-flag"} />
															</td>
															<td colSpan="4">
																<label>توضیح عمومی برای درج در فاکتور:</label>

																<ul className={"comment-text notemarker"}>
																		{(this.state.order.NotePublic || "").split("\n").map((content, key) => {
																		if (content.trim() == "") {
																			return;
																		}
																		return (
																			<li className={"notecontent"} key={key}>
																				{content}
																			</li>
																		);
																	})}
																</ul>
															</td>
														</tr>
													) : (
														<tr />
													)}
													{this.state.order.NotePrivate != null && this.state.order.NotePrivate.trim() !== "" ? (
														<tr>
															<td colSpan="2">
																<div style={{ fontSize: "24px", color: "black" }} className={"glyph-icon simple-icon-ghost"} />
															</td>
															<td colSpan="4">
																<label>توضیح مخفی برای سیستم:</label>

																<ul className={"comment-text notemarker"}>
																		{(this.state.order.NotePrivate || "").split("\n").map((content, key) => {
																		if (content.trim() == "") {
																			return;
																		}
																		return (
																			<li className={"notecontent"} key={key}>
																				{content}
																			</li>
																		);
																	})}
																</ul>
															</td>
														</tr>
													) : (
														<tr />
													)}
													{this.state.order.NoteCustomer != null && this.state.order.NoteCustomer.trim() !== "" ? (
														<tr>
															<td colSpan="2">
																<div style={{ fontSize: "24px", color: "black" }} className={"glyph-icon simple-icon-info"} />
															</td>
															<td colSpan="4">
																<label>توضیحات سفارش (مشتری):</label>

																<ul className={"comment-text notemarker"}>
																		{(this.state.order.NoteCustomer || "").split("\n").map((content, key) => {
																		if (content.trim() == "") {
																			return;
																		}
																		return (
																			<li className={"notecontent"} key={key}>
																				{content}
																			</li>
																		);
																	})}
																</ul>
															</td>
														</tr>
													) : (
														<tr />
													)}
													{this.state.order.NotePayment != null && this.state.order.NotePayment.trim() !== "" ? (
														<tr>
															{console.log(this.state.order.NotePayment)}
															<td colSpan="2">
																<div style={{ fontSize: "24px", color: "black" }} className={"glyph-icon simple-icon-info"} />
															</td>
															<td colSpan="4">
																<label>توضیحات پرداخت:</label>

																<ul className={"comment-text notemarker"}>
																		{(this.state.order.NotePayment || "").split("\n").map((content, key) => {
																		if (content.trim() == "") {
																			return;
																		}
																		return <li className={"notecontent"} key={key} dangerouslySetInnerHTML={{ __html: content }}></li>;
																	})}
																</ul>
															</td>
														</tr>
													) : (
														<tr />
													)}
													{this.state.order.DeliveryInPerson != "0" ? (
														<tr>
															<td colSpan="2">
																<div style={{ cursor: "pointer", fontSize: "24px", color: "black" }} className={"glyph-icon iconsminds-shop-2"} />
															</td>
															<td colSpan="4">
																<label style={{ color: "black" }}>مشتری سفارش را حضوری تحویل میگیرد</label>
															</td>
														</tr>
													) : (
														<tr />
													)}
													{/* <tr>
														<td colSpan="2">
															<div style={{ fontSize: "24px", color: "black" }} className={"glyph-icon simple-icon-star"} />
														</td>
														<td colSpan="4">
															<label>امتیاز اپراتور برای این سفارش:</label>
															<Rating total={5} rating={this.state.order.RatingOperator} interactive={false} style={{ float: "left" }} />
														</td>
													</tr> */}
												</tfoot>
											</table>

											<StateButton
												disabled={this.state.reprintOrderClicked}
												color="light"
												id="reprintorderbtn"
												className="default mb-2 outline-dark-btn float-left"
												style={{ display: "inline-block", float: "left" }}
												onClick={this.handleReprintOrder}
											>
												<i className="simple-icon-printer"></i>&nbsp; پرینت مجدد فاکتور
											</StateButton>
										</CardBody>
										{this.state.LinkVisits.length > 0 ? (
											<div>
												<div className={"cutline"}></div>
												<CardBody>
													<CardTitle>
														<br />
														<div className={"simple-icon-eye headingicon"} />
														بازدید ها از لینک مشتری
													</CardTitle>
													<ul className="visitors-info">
														{this.state.LinkVisits.map((item, index) => {
															return (
																<li className="visitor-info" key={item.LinkVisitId}>
																	<span className={"cardtitleicons"}>
																		<i className={"iconsminds-stopwatch"}></i>
																		{moment(item.VisitTime).locale("fa").format("DD / MMMM / YYYY - HH:mm")}
																	</span>
																	<span className={"cardtitleicons"}>
																		<i className={"simple-icon-globe"}></i>
																		{item.Info.BrowserName} / {item.Info.BrowserVersion}
																	</span>
																	<span className={"cardtitleicons"}>
																		<i
																			className={classNames({
																				"iconsminds-monitor-3 ": item.Info.DeviceType == "desktop",
																				"iconsminds-smartphone-4": item.Info.DeviceType != "desktop",
																			})}
																		></i>
																		{item.Info.OSName} / {item.Info.OSVersion}
																	</span>
																	<br />
																	<span className={"cardtitleicons"}>
																		<i className={"simple-icon-globe-alt"}></i>
																		{item.Info.Country}
																	</span>
																	<span className={"cardtitleicons"}>
																		<i className={"iconsminds-wifi"}></i>
																		{item.Info.IP}
																	</span>
																	<br />
																</li>
															);
														})}
													</ul>
												</CardBody>
											</div>
										) : (
											<div />
										)}
									</Card>
								</Colxx>
							</FormGroup>
						</Form>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class FactorTableRow extends Component {
	render() {
		const {
			data: { OrderProductId, Name, Price, Count },
			index,
		} = this.props;
		var color = index % 2 == 0 ? "#00000005" : "#ffffff";
		return (
			<tr style={{ backgroundColor: color }}>
				<td colSpan={3}>{Name}</td>
				<td style={{ textAlign: "center", width: "80px" }}>
					<NumberFormat style={{ textAlign: "center" }} value={Price} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
				</td>
				<td style={{ textAlign: "center", width: "20px" }}>
					<NumberFormat style={{ textAlign: "center" }} value={Count} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
				</td>
				<td style={{ textAlign: "center", width: "250px" }}>
					<NumberFormat style={{ textAlign: "center" }} value={Price * Count} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
				</td>
			</tr>
		);
	}
}
const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(ViewOrder));
// export default injectIntl(ViewOrder);
